export const ADD_GENNRES_MOVIE = 'ADD_GENNRES_MOVIE';
export const REMOVE_GENNRES_MOVIE = 'REMOVE_GENNRES_MOVIE';
export const REMOVE_ALL_GENNRES_MOVIE = 'REMOVE_ALL_GENNRES_MOVIE';